/* eslint-disable no-console */
/* eslint-disable import/no-named-default */
import React, { useState, useEffect, useMemo } from 'react';
import has from 'lodash/has';
import camelCase from 'lodash/camelCase';
import { useHistory } from 'react-router-dom';
import { default as compose } from 'lodash/flowRight';

import {
  withNTAuthenticator,
  useNTConfig,
  useNTLDFlags,
  useNTLDClient,
  useAuth,
  AuthStatus,
} from '@ntet/fos-auth';

import { withHeader } from '@ntet/fos-nav-bar';
import { MFEContext } from '@ntet/fos-micro-fe';
import MicroFEApp from './MicroFEApp';
import '@ntet/fos-fed-styles/dist/css/styles.css';

const App = React.memo(() => {
  const history = useHistory();
  const ntConfig = useNTConfig();
  const { MicroFE } = ntConfig;
  const flags = useNTLDFlags();
  const client = useNTLDClient();
  const { authState } = useAuth();
  const [state, setState] = useState({
    ldState: null,
    modifiedConfig: MicroFE,
  });

  useEffect(() => {
    if (!client) return;

    client
      .waitForInitialization()
      .then(() => {
        setState((prevState) => {
          const { applications: apps } = prevState.modifiedConfig;

          return {
            ldState: 'initialized',
            modifiedConfig: {
              ...prevState.modifiedConfig,
              applications: apps.filter((app) => {
                const { flag = null } = app;
                const ccFlag = camelCase(flag);

                return !(
                  ccFlag &&
                  has(flags, [ccFlag]) &&
                  flags[ccFlag] === false
                );
              }),
            },
          };
        });
      })
      .catch((err) => {
        console.log(err);
        setState({
          ldState: 'error',
          modifiedConfig: {},
        });
      });
  }, [client, flags]);

  const mfeContext = useMemo(
    () =>
      MFEContext.createContext({
        history,
        ntConfig,
      }),
    [history, ntConfig]
  );

  const { ldState, modifiedConfig } = state;

  if (ldState !== 'initialized' || authState === AuthStatus.LOADING)
    return null;

  return <MicroFEApp context={mfeContext} config={modifiedConfig} />;
});

export default compose(withNTAuthenticator, withHeader)(App);
